import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import { useNavigate } from 'react-router-dom';
import DeviceInsightTable from './DeviceInsightTable';

const DeviceInsights = () => {
  const navigate = useNavigate();
  const [hostName, setHostName] = useState<string>('');

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        {/* You can display hostname in header or wherever you need */}
        <Header title={`Activity Log${hostName ? ` - ${hostName}` : ''}`} dropdown={2} showBackButton={true} />

        {/* Pass callback to receive hostname */}
        <DeviceInsightTable onHostName={setHostName} />
      </div>
    </div>
  );
};

export default DeviceInsights;
